/**
 * UserPermissionsData.js
 * Talkroute
 *
 * Created by Vel Genov on 3/18/20
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

/**
 * A general UserPermissionsData class
 *
 * @param itemBlockedNumber
 * @param itemCallRecording
 * @param itemDid
 * @param itemTextMessaging
 * @param pageCallHistory
 * @param pageVoicemail
 */

export default class UserPermissionsData {
  public itemBlockedNumber: any;
  public itemCallRecording: any;
  public itemDid: any;
  public itemTextMessaging: any;
  public pageCallHistory: any;
  public pageVoicemail: any;

  constructor(opts) {
    this.itemBlockedNumber = opts.itemBlockedNumber;
    this.itemCallRecording = opts.itemCallRecording;
    this.itemDid = opts.itemDid;
    this.itemTextMessaging = opts.itemTextMessaging;
    this.pageCallHistory = opts.pageCallHistory;
    this.pageVoicemail = opts.pageVoicemail;
  }
}